import { useTheme } from "@mui/material"

const useStyles = () => {
    const { breakpoints, palette } = useTheme()
    return {
        alert: ({ ammount }: { ammount: number }) => {
            let color = palette.c_orange.main
            if(ammount > 2) {
                color = palette.c_red.main
            }
            return ({
                borderRadius: '4px',
                padding: '4px 8px',
                background: `${color}44`,
                color: color,
                '& .MuiIcon-root': {
                    height: '1.3em'
                },
                '& .MuiTypography-root': {
                    color: color,
                },
                width: 'fit-content',
                display: 'flex',
                alignItems: 'center',
                gap: 1
            })
        },
        actions: {
            display: 'flex',
            alignItems: 'center',
            gap: 2,
            [breakpoints.down(1460)]: {
                width: '100%',
                justifyContent: 'space-between',
                flexWrap: "wrap"
            }
        },
        container: {
            width: '100%',
            height: '100%',
            padding: '30px 50px 20px 2px',
            display: 'flex',
            flexDirection: 'column',
            gap: 2
        },
        header: {
            display: 'flex',
            justifyContent: 'space-between',
            width: '100%',
            alignItems: 'center',
            [breakpoints.down(1460)]: {
                display: 'block',
            }
        },
        body: {
            padding: '16px 24px',
            display: 'flex',
            flexDirection: 'column',
            gap: 2
        },
        footer: {
            display: 'flex',
            flexDirection: 'column',

        },
        comments: {
            display: 'flex',
            flexDirection: 'column',
            gap: 2,
            margin: '0px auto',
            width: '100%',
            [breakpoints.up('lg')]: {
                width: '80%',
            }
        },
        backButton: {
            /* minWidth:'245px', */
            padding: '6px 6px 6px 0px',
            justifyContent: 'flex-start',
            marginRight: '10px'
          
        }
    }
}

export { useStyles }
